import Vue from "vue";

export default Vue.extend({
  props: {
    dropped: {
      type: Boolean,
      required: true,
    },
    stylings: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isDropped: false,
      clickOutsideCallback: null,
    };
  },
  methods: {
    toggleMenu(override) {
      this.isDropped = override !== undefined ? override : !this.isDropped;
    },
  },
  directives: {
    "click-outside": {
      bind: (el, binding, vnode) => {
        const clickOutsideCallback = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context.toggleMenu(false);
          }
        };
        document.body.addEventListener("mousedown", clickOutsideCallback);
        document.body.addEventListener("touchstart", clickOutsideCallback);
      },
      unbind: (el, vnode) => {
        const clickOutsideCallback = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context.toggleMenu(false);
          }
        };
        document.body.removeEventListener("mousedown", clickOutsideCallback);
        document.body.removeEventListener("touchstart", clickOutsideCallback);
      },
    },
  },
  watch: {
    dropped() {
      this.isDropped = this.dropped;
    },
    isDropped() {
      this.$emit("update:dropped", this.isDropped);
    },
  },
});
